import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton
} from '@mui/material';
import {
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  Twitter as TwitterIcon,
  YouTube as YouTubeIcon
} from '@mui/icons-material';
import './SocialLinks.css';

const SocialLinks = () => {
  const socialNetworks = [
    {
      name: 'Facebook',
      icon: <FacebookIcon />,
      url: 'https://facebook.com/missionsport',
      color: '#1877F2',
      description: 'Suivez nos actualités et événements'
    },
    {
      name: 'Instagram',
      icon: <InstagramIcon />,
      url: 'https://instagram.com/missionsport',
      color: '#E4405F',
      description: 'Photos et stories de nos missions'
    },
    {
      name: 'LinkedIn',
      icon: <LinkedInIcon />,
      url: 'https://linkedin.com/company/missionsport',
      color: '#0A66C2',
      description: 'Réseau professionnel et opportunités'
    },
    {
      name: 'Twitter',
      icon: <TwitterIcon />,
      url: 'https://twitter.com/missionsport',
      color: '#1DA1F2',
      description: 'Actualités en temps réel'
    },
    {
      name: 'YouTube',
      icon: <YouTubeIcon />,
      url: 'https://youtube.com/missionsport',
      color: '#FF0000',
      description: 'Vidéos et témoignages'
    }
  ];

  const handleSocialClick = (url, name) => {
    // Analytics tracking could be added here
    console.log(`Opening ${name}: ${url}`);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box className="social-links">
      <Typography variant="h4" component="h2" className="social-title" gutterBottom>
        Suivez-nous
      </Typography>
      
      <Typography variant="body1" className="social-subtitle" sx={{ mb: 3 }}>
        Restez connectés avec la communauté Mission Sport sur nos réseaux sociaux.
      </Typography>

      <Box className="social-icons-container">
        {socialNetworks.map((network) => (
          <IconButton 
            key={network.name}
            className="social-icon-btn-simple"
            onClick={() => handleSocialClick(network.url, network.name)}
            title={`${network.name} - ${network.description}`}
            style={{ color: network.color }}
            size="large"
          >
            {network.icon}
          </IconButton>
        ))}
      </Box>

      <Card className="social-cta-card">
        <CardContent>
          <Typography variant="h6" className="cta-title" gutterBottom>
            Rejoignez notre communauté !
          </Typography>
          <Typography variant="body2" className="cta-text">
            🏃‍♂️ Plus de 10 000 passionnés de sport nous suivent déjà
          </Typography>
          <Typography variant="body2" className="cta-text">
            📱 Contenus exclusifs et avant-premières
          </Typography>
          <Typography variant="body2" className="cta-text">
            🎯 Conseils d'experts et témoignages inspirants
          </Typography>
        </CardContent>
      </Card>

      <Box className="social-footer">
        <Typography variant="body2" className="social-footer-text">
          Partagez vos expériences avec le hashtag <strong>#MissionSport</strong>
        </Typography>
      </Box>
    </Box>
  );
};

export default SocialLinks;